import { render, staticRenderFns } from "./TaxaOcupacaoPorUnidade.vue?vue&type=template&id=4168c292&scoped=true"
import script from "./TaxaOcupacaoPorUnidade.vue?vue&type=script&lang=js"
export * from "./TaxaOcupacaoPorUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4168c292",
  null
  
)

export default component.exports